import React from "react";

import TagSvg from "../../assets/images/icons/tag.svg";

export const TagIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={TagSvg}
        alt={alt || "Tag"}
    />
);
